<template>
  <div>
    <div v-if="notice.noticeFile" class="notice_image">
      <img :src="notice.noticeFile" alt="">
    </div>
    <div class="notice">
      <div class="notice_title">{{notice.noticeTitle}}</div>
      <p class="notice_content" v-html="notice.noticeContent"></p>
      <div class="notice_time">{{notice.createTime}}</div>
    </div>
  </div>
</template>

<script>
import { getNotice } from '@/api/admi/user'
import { Toast } from 'vant'
export default {
  name: 'noticeDetail',
  components: {
    [Toast.name]: Toast
  },
  data() {
    return {
      noticeId: '',
      notice: {}
    }
  },
  created() {
    // this.handleList()
    this.noticeId = this.$route.query.noticeId
    this.getNotice(this.$route.query.noticeId)
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '通知详情'
    },
    async getNotice(id) {
      const res = await getNotice(id)
      if (res.code == 200) {
        this.notice = res.data
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.notice_image{
  padding: 20px;
  border-bottom: 1px solid #d4d4d4;
  img{
    max-width: 100%;
  }
}
.notice{
  padding: 20px;
}
.notice_title{
  width: 100%;
  color: #333;
  font-size: 34px;
  font-weight: bold;
  text-align: center;
  line-height: 100px;
}
.notice_content{
  font-size: 30px;
  color: #333;
  text-indent: 2em;
  line-height: 50px;
}
.notice_time{
  display: flex;
  justify-content: flex-end;
  font-size: 30px;
  color: #333;
}
</style>
